

import PropTypes from "prop-types";
export const preprocessText = (text) => {
  if (!text) return "";

  if (Array.isArray(text)) {
    text = text.map(item => (typeof item === 'object' ? JSON.stringify(item) : String(item))).join('\n');
  } else if (typeof text === 'object') {
    text = JSON.stringify(text, null, 2);
  } else {
    text = String(text);
  }

  return (
    text
      .replace(/\\n/g, "\n") // Convert escaped newlines
      .replace(/\\t/g, "    ") // Convert escaped tabs
      .replace(/\*\*(.*?)\*\*/g, "**$1**") // Bold
      .replace(/\*(.*?)\*/g, "*$1*") // Italics
      .replace(/`(.*?)`/g, "`$1`") // Inline code
      .replace(/\\\\/g, "\\") // Escaped backslashes
      // Add extra newline after headings
      .replace(/^(#+ .+)$/gm, "$1\n")
      // Add extra newline after unordered lists
      .replace(/(<ul>.*?<\/ul>)/gs, "$1\n")
      .trim()
  );
};

export const CustomLink = ({ children, ...props }) => {
  return (
    <a
      {...props}
      className="text-[#0645AD]"
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
};

CustomLink.propTypes = {
  children: PropTypes.node.isRequired, // or PropTypes.node if optional
};

export const openBase64Image = (base64Data) => {
  const byteString = atob(base64Data.split(",")[1]);
  const mimeType = base64Data.split(",")[0].match(/:(.*?);/)[1];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: mimeType });
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, "_blank");
};
